import styled, { css } from 'styled-components';
import { ArrowDown } from '@carvana/icons';
import { Carousel } from '@carvana/showroom-carousel';
import { cvBreakpoint768, cvBreakpoint1024 } from '@carvana/theme';
import dayPickerStyles from './day-picker.styles';

export const DayPickerWrapper = styled.div`
  ${dayPickerStyles}
`;

export const DownArrow = styled(ArrowDown)`
  color: ${props => props.theme.carvana.gray.dark};
  transform: ${props => (props.rotate ? 'rotate(180deg)' : 'rotate(0deg)')};
  & > svg {
    width: 10px;
    height: 10px;
  }
`;

export const HideCalendar = styled.div`
  color: ${props => props.theme.carvana.gray.dark};
  cursor: pointer;
  padding: 20px 0px;
  text-decoration: underline;
  width: 300px;
`;

const scrollBarStyles = css`
  /* width */
  ::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 2px;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: ${props => props.theme.carvana.blue.hover};
    border-radius: 2px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: ${props => props.theme.carvana.blue.hover};
  }
`;

export const StyledCarousel = styled(Carousel)`
  & button {
    height: 45px;
    width: 45px;
  }
`;

export const SelectTimeWrapper = styled.div`
  @media (max-width: 1023px) {
    ${scrollBarStyles}
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    flex-wrap: nowrap;
    max-height: 300px;
    max-width: 330px;
    margin-top: 30px;
    overflow-y: hidden;
    overflow-x: scroll;
    position: relative;
  }

  @media (min-width: ${cvBreakpoint1024}px) {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    max-height: 300px;
    margin-top: 30px;
    align-items: center;
    justify-content: center;
    overflow-y: hidden;
    overflow-x: hidden;
    position: relative;
    min-width: 420px;
    max-width: 440px;
  }
`;

export const SelectTimeWindowWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  max-height: 320px;
  max-width: 315px;
  margin-top: 24px;
`;

export const Titles = styled.div`
  padding: 10px 0px 0px 0px;
  font-weight: 700;
  font-size: 18px;
  display: inline-flex;
  min-width: 300px;
`;

export const TitlesWindow = styled.div`
  padding: 10px 0px 0px 0px;
  font-weight: 700;
  font-size: 18px;
  display: inline-flex;
  min-width: 300px;
  flex-direction: column;
`;

export const TimeWrapper = styled.div`
  padding-left: 0px;
`;

export const TimeSlotWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 380px;
  margin-top: 15px;
  transform: scale(1, 1);
`;

export const TimeZoneTitle = styled.p`
  color: ${props => props.theme.carvana.gray.dark};
  font-weight: 400;
  font-size: 14px;
`;

export const VerticalDivider = styled.span`
  border: 0;
  border-left: 1px solid ${props => props.theme.carvana.gray.light};
  margin-top: 30px;
`;
